import { Fragment, useState } from "react";

import { Element } from "@craftjs/core";
import { LayoutGrid, LayoutPanelTop } from "lucide-react";
import { cn } from "twyne-new.ui";

import { define, variant } from "@/components/builder/utils";

import { GridContainerBlock, GridItemBlock } from "..";
import BasePreview from "../base";

function GridPreview({ properties }) {
  const { grid: { rows, columns } } = properties

  return <BasePreview>
    <div>
      <Element is={GridContainerBlock} id='grid' canvas properties={properties}>
        {Array.from({ length: rows * columns }).map((_, idx) => <Element is={GridItemBlock} canvas key={idx} />)}
      </Element>
    </div>
  </BasePreview>
}

const MAX_COLS = 6
const MAX_ROWS = 6

function VariantPreview({ onChangeProps, label }) {
  const [hovered, setHovered] = useState([-1, -1])
  const [active, setActive] = useState(false)

  const [rows, columns] = hovered.map(index => index + 1)
  const caption = active && rows && columns ? `${rows} \u00d7 ${columns}` : 'pick a size'

  const handleChange = (ridx, cidx) => () => {
    setHovered([ridx, cidx])
    onChangeProps({
      grid: {
        rows: ridx + 1,
        columns: cidx + 1,
      },
    })
  }

  return <div className='rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-900/60'>
    <div className='mb-3 flex items-center justify-between gap-2'>
      <span className='flex items-center gap-2 font-semibold text-gray-900 dark:text-gray-100'>
        <LayoutGrid size={16} className='text-gray-500 dark:text-gray-400' />
        {label}
      </span>
      <span className={cn('font-mono text-sm transition-colors', active ? 'text-blue-500 dark:text-blue-300' : 'text-gray-500 dark:text-gray-400')}>
        {caption}
      </span>
    </div>
    <div
      className={`grid grid-cols-${MAX_COLS} gap-2`}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      {Array
        .from({ length: MAX_ROWS })
        .map((_, ridx) => Array
          .from({ length: MAX_COLS })
          .map((_, cidx) => {
            const isSelected = active && ridx <= hovered[0] && cidx <= hovered[1]

            return <div
              key={`${ridx}-${cidx}`}
              onMouseEnter={handleChange(ridx, cidx)}
              className={cn('aspect-square rounded-md border transition-colors duration-200', {
                'border-blue-500 bg-blue-500': isSelected,
                'border-gray-300 bg-gray-100 dark:border-gray-700 dark:bg-gray-800': !isSelected,
              })}
            />
          }))}
    </div>
  </div>
}

export default define('grid', GridPreview, Fragment)
  .variant(variant(VariantPreview, null)
    .add('grid-table', 'Grid Table', { layoutType: 'grid' }, { card: true }))
  .palete(<LayoutPanelTop size={16} />, 'Grid', 'Structures')
  .defaultProps({})
  .build()
